import {
    BackButton,
    LeftContentWrapper,
    StyledH1,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { GIFT_DETAILS_STEP } from '@/src/modules/pg-plus/redemption/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import PGPlusFAQs from '@/src/modules/pg-plus/redemption/builder-symbols/PGPlusFAQs'
import { styled } from '@/src/stitches.config'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { DISPATCH_SET_STEP } from '@/src/common/reducers/constants'
import { FAQ_PAGE } from '../../constants'

const StyledLeftContentWrapper = styled(LeftContentWrapper, {
    width: '$default',
    maxWidth: '$defaultMax',
    p: 0,
    pb: 40,
    margin: 'auto',
    '& p, h1': {
        width: 550,
        maxWidth: '100%',
    },
    '& a': {
        color: '$primary',
        fontWeight: 'bold',
    },
})

interface IGiftNotFound {
    builderContentJson: any
    routerAction?: Function
    showBackButton?: boolean
}

const GiftNotFound = ({
    builderContentJson,
    routerAction,
    showBackButton = true,
}: IGiftNotFound) => {
    const { dispatch } = usePGPlusStepAndModalContext()
    return (
        <>
            <StyledLeftContentWrapper>
                {showBackButton && (
                    <BackButton
                        data-testid={'backButton'}
                        onClick={() => {
                            routerAction
                                ? routerAction()
                                : dispatch({
                                      type: DISPATCH_SET_STEP,
                                      payload: { stepName: GIFT_DETAILS_STEP },
                                  })
                        }}
                        marginTop={'marginTop30'}
                    >
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            style={{ marginRight: '0.5rem' }}
                        />
                        Back
                    </BackButton>
                )}
                <StyledH1 data-testid={'failure-h1'}>
                    Unable to locate gift.
                </StyledH1>
                <p style={{ lineHeight: '1.5rem' }}>
                    We were unable to locate your gift. Please refresh the page
                    and try again. If issues persist, please see our list of{' '}
                    <a href={FAQ_PAGE}>frequently asked questions</a>.
                </p>
            </StyledLeftContentWrapper>
            <PGPlusFAQs builderContentJson={builderContentJson} />
        </>
    )
}
export default GiftNotFound
